import { render, staticRenderFns } from "./CourseRegistration.vue?vue&type=template&id=bb6495c6&scoped=true"
import script from "./CourseRegistration.vue?vue&type=script&lang=js"
export * from "./CourseRegistration.vue?vue&type=script&lang=js"
import style0 from "./CourseRegistration.vue?vue&type=style&index=0&id=bb6495c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6495c6",
  null
  
)

export default component.exports